import * as React from 'react';
import { observer } from 'mobx-react';
import { FieldState } from 'formstate';
import ContractDropdownItem from 'components/ContractDropdownItem';
import { languageStore, AppraisalStatusEnum } from 'stores';
import { DropdownOptionInterface } from 'components/Forms/Dropdown';

interface Props {
    fieldState: FieldState<any>,
    editMode?: boolean,
}

@observer class SelectSatisfaction extends React.Component<Props> {

    render() {
        const { fieldState, editMode } = this.props;

        const dropdownOpts = [
            {
                value: AppraisalStatusEnum.SATISFIED,
                name: languageStore.get('satisfied')
            },
            {
                value: AppraisalStatusEnum.LESS_DISSATISFIED,
                name: languageStore.get('lessSatisfied')
            },
            {
                value: AppraisalStatusEnum.LESS_DISSATISFIED,
                name: languageStore.get('lessDissatisfied')
            },
            {
                value: AppraisalStatusEnum.DIS_SATISFIED,
                name: languageStore.get('disSatisfied')
            }
        ] as Array<DropdownOptionInterface>

        return (
            <ContractDropdownItem
                label={languageStore.get('satisfaction')}
                id='satisfaction'
                placeholderText={languageStore.get('select')}
                fieldState={fieldState}
                options={dropdownOpts}
                skipSort={true}
                type='number'
                editMode={editMode} />
        )
    }

}

export default SelectSatisfaction;